import script from "./BicycleComputer.vue?vue&type=script&setup=true&lang=js"
export * from "./BicycleComputer.vue?vue&type=script&setup=true&lang=js"

import "./BicycleComputer.vue?vue&type=style&index=0&id=b50cf792&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b50cf792"]])

export default __exports__